import { render, staticRenderFns } from "./DynamicContent.vue?vue&type=template&id=8a2ab49a&scoped=true&"
import script from "./DynamicContent.vue?vue&type=script&lang=ts&"
export * from "./DynamicContent.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicContent.vue?vue&type=style&index=0&id=8a2ab49a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2ab49a",
  null
  
)

export default component.exports